import { Lightbulb } from '@phosphor-icons/react';

const PlainLanguageInterpretation = ({ interpretation, stabilityMeta }) => (
  <div className="bg-white border-l-4 border-teal-600 rounded-r-lg p-8 shadow-sm mb-8" data-testid="plain-language-interpretation">
    <div className="flex items-start gap-4">
      <div className="flex-shrink-0 mt-1">
        <Lightbulb size={28} weight="duotone" className="text-teal-600" />
      </div>
      <div>
        <h3 className="text-xl font-semibold text-slate-900 mb-2">
          What this means for you
        </h3>
        <p className="text-slate-700 leading-relaxed">
          {interpretation}
        </p>
        <div className="mt-4 text-sm text-slate-600">
          SMART Phase: <strong className="text-teal-700">{stabilityMeta.smartPhase}</strong>
        </div>
      </div>
    </div>
  </div>
);

export default PlainLanguageInterpretation;
